
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lead",
      function () {
        return require("private-next-pages/lead.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lead"])
      });
    }
  